import { createSelector } from 'reselect';

import { browserBarOpenSelector } from '@xingternal/platform-layout-selectors';

const bottomBarSelector = createSelector(
  browserBarOpenSelector,
  (browserBarOpen) => {
    return {
      browserBarOpen,
    };
  }
);

export { bottomBarSelector };
